<template>
  <div class="car_list_descr mr-0" v-if="infocar">
    <div class="car_list_cont">
      <div class="car-title">{{ infocar.nome }}</div>
      <div class="car-descr">
        <div class="car_container">
          <div v-if="infocar.img" class="img_car">
            <img :src="infocar.img" :alt="infocar.nome"/>
          </div>
          <div v-else class="img_car_classic">
            <img
              :src="defaultCarImage"
              alt="auto icon"
              width="140px"
            />
          </div>
          <div class="row_descr row_descr_2">
            <div class="border-right">
              <div v-for="(item, index) in leftColumn" :key="index" class="single_row">
                <span class="label-bold">{{ item.label }}:</span>
                <span>{{ item.value }}</span>
              </div>
            </div>
            <div>
              <div v-for="(item, index) in rightColumn" :key="index" class="single_row">
                <span class="label-bold">{{ item.label }}:</span>
                <span>{{ item.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarRecap',
  props: {
    infocar: {
      type: Object,
      required: true,
    },
    quotationType: {
        type: String,
        required: true,
      },
  },
  computed: {
    leftColumn() {
      return [
        { label: 'Cilindrata', value: this.infocar.cilindrata },
        { label: 'Potenza', value: this.infocar.potenza },
        { label: 'Trazione', value: this.infocar.trazione },
        { label: 'Cambio', value: this.infocar.cambio },
        { label: 'Alimentazione', value: this.infocar.alimentazione },
      ];
    },
    rightColumn() {
      return [
        { label: 'Velocità max', value: this.infocar.velocitaMax },
        { label: 'Carrozzeria', value: this.infocar.carrozzeria },
        { label: 'Porte', value: this.infocar.porte },
        { label: 'Posti', value: this.infocar.posti },
        { label: 'Consumi', value: this.infocar.consumi },
      ];
    },
    defaultCarImage() {
      return this.quotationType === 'ruote-classiche'
        ? require('../../../images/project-img/ico-classic-grey.png')
        : require('../../../images/project-img/Ico-auto-grey.png');
    },
  },
};
</script>
<style scoped>
.img_car_classic {
  margin-left: 18px;
  width: 375px;
  height: 175px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: #d9d9d9;
  img {
    max-width: 275px;
  }
  @media (max-width: 768px) {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/CarRecap.vue